export const NAME = 'App';



// WEBPACK FOOTER //
// ./modules/App/redux/constants.js